import styled, { css } from 'styled-components';

import { BREAKPOINTS } from '@shared/styled-system';

export const Container = styled.div`
	padding-top: 32px;
	margin: 0 auto;
	max-width: 1430px;
`;

export const Item = styled.div`
	margin-bottom: 24px;

	border-bottom: 1px solid rgba(220, 220, 220, 0.1);
`;

export const Question = styled.div`
	color: ${({ theme }) => theme.colors.text.subtitle};
	display: flex;
	justify-content: space-between;
	gap: 15px;
	padding-bottom: 18px;
	padding-top: 18px;

	@media (${BREAKPOINTS.MOBILE}) {
		cursor: pointer;
	}
`;

export const QuestionTitle = styled.div`
	font-size: 24px;
	font-weight: 600;
	display: inline-flex;
	align-items: center;

	@media (max-width: 500px) {
		font-size: 20px;
	}
`;

export const Arrow = styled.div<{ $isOpen: boolean }>`
	align-items: center;
	border-radius: 8px;
	display: none;
	justify-content: center;
	height: 40px;
	transition: all 0.1s linear;
	min-width: 40px;
	width: 40px;

	transform: rotate(-90deg);

	${({ $isOpen }) =>
		$isOpen &&
		css`
			transform: rotate(90deg);
		`}

	@media (${BREAKPOINTS.MOBILE}) {
		display: flex;
	}

	svg {
		width: 24px;
		fill: ${({ theme }) => theme.colors.icon.chevron};
	}
`;

export const Answer = styled.div<{ $isOpen: boolean }>`
	color: ${({ theme }) => theme.colors.text.body};
	line-height: 150%;
	padding-bottom: 24px;
	font-size: 16px;

	@media (${BREAKPOINTS.MOBILE}) {
		display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
	}

	*,
	p {
		color: ${({ theme }) => theme.colors.text.body};
		margin: 0;
	}

	a {
		color: ${({ theme }) => theme.colors.text.link};
	}

	@media (max-width: 500px) {
		font-size: 16px;
	}
`;

export const Help = styled.div`
	display: flex;
	gap: 20px;
	margin-top: 16px;
`;

export const Tg = styled.a`
	align-items: center;
	background-color: #19334f;
	border-radius: 8px;
	display: flex;
	justify-content: center;
	height: 56px;
	transition: all 0.2s linear;
	width: 64px;

	&:hover {
		background-color: #244971;
	}
`;

export const Phone = styled.a`
	align-items: center;
	background-color: #3a2159;
	border-radius: 8px;
	color: #ae6fff;
	display: flex;
	gap: 8px;
	justify-content: center;
	height: 56px;
	transition: all 0.2s linear;
	padding-right: 8px;
	padding-left: 8px;

	&:hover {
		background-color: #4a2c6f;
	}
`;

export const List = styled.ul``;

export const ListItem = styled.li`
	display: flex;
	gap: 8px;
`;
